import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { StickerInterface, setEditId, setEditError, selectStickerById } from "../../../store/sticker_maker/stickersSlice";
import { updateSticker, fetchSticker } from "../../../actions/sticker_maker/stickersActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.stickerMaker.stickers.editId);
  const error     = useAppSelector(state => state.stickerMaker.stickers.editError);
  const sticker   = useAppSelector(state => id ? selectStickerById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchSticker(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: StickerInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: StickerInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateSticker({ id, data: formData }));

    if (updateSticker.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-sticker'>
        <h6 className="v-content-label">Edit Sticker</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={sticker} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
